import React from "react";
import { useNavigate } from "react-router-dom";
import { PayPalScriptProvider, PayPalButtons, FUNDING } from "@paypal/react-paypal-js";

const PayPalPayment = props => {
  const { storeId, shippingId, paymentMethod, productPrice, currency } = props;
  const navigate = useNavigate();

  const mapToPaypalCurrencyCode = value => {
    const normalized = String(value || "").trim().toUpperCase();
    if (normalized === "€" || normalized === "EUR") return "EUR";
    if (normalized === "CHF") return "CHF";
    if (normalized === "$" || normalized === "USD") return "USD";
    return "USD";
  };

  const paypalCurrency = mapToPaypalCurrencyCode(currency);
  const amountAsNumber = Number(productPrice);
  const normalizedAmount = Number.isFinite(amountAsNumber) && amountAsNumber > 0 ? amountAsNumber.toFixed(2) : null;

  const redirectToPaymentFailed = message => {
    navigate("/payment-failed", { state: { message: message || "Payment failed" } });
  };

  const paypalOptions = {
    "client-id": props?.paypalCreds?.client_id,
    currency: paypalCurrency,
  };

  const createOrder = (data, actions) => {
    if (!normalizedAmount) {
      throw new Error("Invalid payment amount");
    }

    return actions.order
      .create({
        purchase_units: [
          {
            amount: {
              currency_code: paypalCurrency,
              value: normalizedAmount,
            },
          },
        ],
        application_context: {
          shipping_preference: "NO_SHIPPING",
        },
      })
      .then(orderID => {
        return orderID;
      });
  };

  const onApprove = (data, actions) => {
    return actions.order
      .capture()
      .then(function (details) {
        navigate("/payment-success", {
          state: {
            finalizeOrder: true,
            orderPayload: {
              store_id: storeId,
              shipping_id: shippingId,
              payment_method: paymentMethod,
            },
            paypal: {
              orderID: data?.orderID,
              payerID: data?.payerID,
              captureID: details?.purchase_units?.[0]?.payments?.captures?.[0]?.id,
            },
          },
        });
      })
      .catch(() => {
        redirectToPaymentFailed("Payment capture failed.");
      });
  };

  const onError = () => {
    redirectToPaymentFailed("Payment failed.");
  };

  const onCancel = () => {
    return;
  };

  return (
    <PayPalScriptProvider options={paypalOptions}>
      <PayPalButtons
        style={{
          layout: "horizontal",
          color: "white",
          shape: "rect",
        }}
        fundingSource={FUNDING.PAYPAL}
        disabled={!normalizedAmount}
        forceReRender={[normalizedAmount, paypalCurrency]}
        createOrder={createOrder}
        onApprove={onApprove}
        onError={onError}
        onCancel={onCancel}
        label="Custom Label"
      />
    </PayPalScriptProvider>
  );
};

export default PayPalPayment;
